import { ModeToggle } from "./mode-toggle";
import React from 'react';

import { SidebarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator, BreadcrumbLink } from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { Link, useRouterState } from "@tanstack/react-router";
import { OfflineIndicator } from "@/components/offline-indicator";
import { useMediaQuery } from "@uidotdev/usehooks";
import { SyncButton } from "./sync-button";

// Helper function to format path segments into readable names
const formatSegment = (segment: string) => {
	if (!segment) return 'Home';
	return segment
		.split('-')
		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
};

export default function Header() {
	const isMobile = useMediaQuery("(max-width: 425px)");
	const { toggleSidebar } = useSidebar();
	const { location } = useRouterState();
	const pathSegments = location.pathname.split('/').filter(Boolean); // Split and remove empty strings

	return (
		<header className="flex sticky top-0 z-50 w-full items-center border-b bg-background">
			<div className="flex w-full justify-between items-center gap-2 p-4">
				<div className="flex items-center gap-2">
					<Button className="h-8 w-8" variant="outline" size="icon" onClick={toggleSidebar}>
						<SidebarIcon />
					</Button>
					<Separator orientation="vertical" className="mr-2 h-4" />
					<Breadcrumb className="hidden sm:block">
						<BreadcrumbList>
							<BreadcrumbItem>
								<BreadcrumbLink asChild>
									<Link to="/">Shamba ODK</Link>
								</BreadcrumbLink>
							</BreadcrumbItem>
							{!isMobile && pathSegments.map((segment, index) => {
								const isLast = index === pathSegments.length - 1;
								const pathToSegment = `/${pathSegments.slice(0, index + 1).join('/')}`;
								return (
									<React.Fragment key={segment}>
										<BreadcrumbSeparator />
										<BreadcrumbItem>
											{isLast ? (
												<BreadcrumbPage>{formatSegment(segment)}</BreadcrumbPage>
											) : (
												<BreadcrumbLink asChild>
													<Link to={pathToSegment}>{formatSegment(segment)}</Link>
												</BreadcrumbLink>
											)}
										</BreadcrumbItem>
									</React.Fragment>
								);
							})}
						</BreadcrumbList>
					</Breadcrumb>
				</div>

				<div className="flex items-center gap-4">
					<OfflineIndicator />
					<SyncButton header />
					<ModeToggle />
				</div>
			</div>
		</header>
	);
}
